module.exports = __webpack_public_path__ + "img/quote-bg.8715e8bf.jpg";